import UserStore from '../stores/UserStore';

/**
 * Safely get translations from UserStore
 * @param {string} path - Path to translation (e.g., 'currencyPage.table', 'auth.rightsPhrase')
 * @param {*} defaultValue - Default value if translation not found
 * @returns {*} Translation value or default value
 */
export const getTranslation = (path = '', defaultValue = {}) => {
    try {
        const translation = UserStore.getTranslation();
        if (!translation) return defaultValue;
        
        if (!path) return translation;
        
        // Navigate through nested object using dot notation
        const keys = path.split('.');
        let result = translation;
        
        for (const key of keys) {
            if (result && typeof result === 'object' && key in result) {
                result = result[key];
            } else {
                return defaultValue;
            }
        }
        
        return result || defaultValue;
    } catch (error) {
        console.warn('Error getting translation:', error);
        return defaultValue;
    }
};

/**
 * Get translation with fallback to key if not found
 * @param {string} key - Translation key
 * @param {string} path - Path to translation section
 * @returns {string} Translation or key as fallback
 */
export const getTranslationKey = (key, path = '') => {
    const translations = getTranslation(path, {});
    return translations[key] || key;
};

export default {
    getTranslation,
    getTranslationKey
};
